import {FormBlock} from '../form-block';
import ShiftScheduleItem from './shift-schedule-item';
import ShiftScheduleForm from './shift-schedule-form';
import React, {useState} from 'react';
import {ShiftSchedule, CycleType, WorkType} from '../../../../api/types';
import {useForm, FormProvider} from 'react-hook-form';
import * as uuid from 'uuid';
import {DeleteDialog} from '../../../../components/Dialog';
import ShiftInfo from '../shift-info';

type ShiftScheduleProps = {
  list: ShiftSchedule[];
  selected: string[];
  onChange: (list: ShiftSchedule[]) => void;
};
const initShiftSchedule = {
  cycleType: CycleType.weekly,
  cycles: {
    sunday: WorkType.vacation,
    monday: WorkType.work,
    tuesday: WorkType.work,
    wednesday: WorkType.work,
    thursday: WorkType.work,
    friday: WorkType.work,
    saturday: WorkType.dayOff,
  }
}
function ShiftScheduleBlock({list, onChange, selected}: ShiftScheduleProps) {
  const [showShiftScheduleForm, setShowShiftScheduleForm] = useState(false);
  const [triggerValidate, setTriggerValidate] = useState(false);
  const [deleteId, setDeleteId] = useState<null | string>(null);
  const methods = useForm<ShiftSchedule>({ mode: 'onChange' });
  const {reset} = methods;
  return (
    <FormBlock
      title={
        <span>
          步驟1. 班次設定
          <ShiftInfo />
        </span>
      }
      formType={'班次'}
      onAddItem={() => {
        reset(initShiftSchedule);
        setShowShiftScheduleForm(true);
      }}
      data-test-id={'shift-schedule'}
    >
      {list?.map((item, idx) => {
        const hasError = Object.keys(item?.error || {}).length > 0
        return (
          <ShiftScheduleItem
            key={`shift_schedule_item_${idx}`}
            item={item}
            idx={idx}
            onEdit={item => {
              reset(item);
              setShowShiftScheduleForm(true);
              if (hasError) {
                setTriggerValidate(true);
              }
            }}
            onRemove={id => setDeleteId(id)}
            disabled={selected.indexOf(item.id) !== -1}
            deletable={idx !== 0}
            error={hasError}
          />
        );
      })}
      <FormProvider {...methods}>
        <ShiftScheduleForm
          isOpen={showShiftScheduleForm}
          onConfirm={data => {
            delete data.error
            if (data.cycleType === CycleType.none) {
              data.cycles = {};
            }
            if (data.id) {
              const idx = list.findIndex(i => i.id === data.id);
              if (idx !== -1) {
                onChange([
                  ...list.slice(0, idx),
                  data,
                  ...list.slice(idx + 1, list.length),
                ]);
              }
            } else {
              onChange([...list, {...data, id: uuid.v4()}]);
            }
            setShowShiftScheduleForm(false);
            setTriggerValidate(false);
          }}
          onClose={() => {
            reset(initShiftSchedule);
            setShowShiftScheduleForm(false)
            setTriggerValidate(false);
          }}
          triggerValidate={triggerValidate}
        />
      </FormProvider>
      <DeleteDialog
        isOpen={deleteId !== null}
        onCancel={() => setDeleteId(null)}
        onConfirm={() => {
          onChange(list.filter(i => i.id !== deleteId));
          setDeleteId(null);
        }}
      />
    </FormBlock>
  );
}

export default ShiftScheduleBlock;
